// Phase 2 — semantic typography tokens
//
// Semantic typography assigns named roles to values from bsky/tokens
// (fontSize, fontWeight, lineHeight), so components reference a role
// ("body text", "caption") rather than raw numbers. Will be populated
// once font scale gaps in Figma are resolved (see FIGMA_DESIGN_SYSTEM_UPDATES.md,
// Part 3).
//
// Non-semantic typography (direct t-shirt sizes) is already available via
// ALF atoms: atoms.text_sm, atoms.font_bold, atoms.leading_snug, etc.

export const typography = {} as const

export type Typography = typeof typography
